// src/features/loading/loadingSlice.js
import { createSlice } from "@reduxjs/toolkit";

const loadingSlice = createSlice({
  name: "loading",
  initialState: {
    isLoading: false,
    ringStatuses: false,
  },
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setRingStatuses: (state, action) => {
      state.ringStatuses = action.payload;
    },
  },
});

export const { setIsLoading, setRingStatuses } = loadingSlice.actions;
export default loadingSlice.reducer;
